import { useDraggable } from "@dnd-kit/core";
import WidgetItem, { WidgetItemInterface } from "./widget-item";
import { WidgetLibraryItem } from "../../../utils/util-types";

export default function DraggableWidgetItem({
  widget,
  onAddClick,
  onRemoveClick,
}: WidgetItemInterface) {
  // const { setNodeRef, listeners, attributes } = useDraggable({
  //   id: widget.id,
  //   data: widget,
  // });

  return (
    // ref={setNodeRef} {...listeners} {...attributes}
    <div>
      <WidgetItem
        widget={widget}
        onAddClick={onAddClick}
        onRemoveClick={onRemoveClick}
      />
    </div>
  );
}
